import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-grey-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_media = _resolveComponent("post-media")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_post_time_bar = _resolveComponent("post-time-bar")!
  const _component_post_toolbar = _resolveComponent("post-toolbar")!
  const _component_post_content = _resolveComponent("post-content")!
  const _component_post_actions = _resolveComponent("post-actions")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass([_ctx.cssClass, "post"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_post_media, {
          "post-id": _ctx.post.id,
          media: _ctx.post.media,
          highlightTranscript: _ctx.highlightTranscript,
          "aspect-ratio": _ctx.mediaAspectRatio,
          class: "post__media"
        }, null, 8, ["post-id", "media", "highlightTranscript", "aspect-ratio"])
      ]),
      (_ctx.showClient)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {name: 'client_profile', params: {clientId: _ctx.clientId}},
            class: "q-pa-sm q-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientName), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_post_time_bar, { post: _ctx.post }, null, 8, ["post"]),
      _createVNode(_component_post_toolbar, {
        post: _ctx.post,
        actions: _ctx.actions,
        group: _ctx.showGroup,
        notes: _ctx.notes,
        trash: _ctx.trash,
        onTrashed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('trashed', $event)))
      }, null, 8, ["post", "actions", "group", "notes", "trash"]),
      _createVNode(_component_post_content, {
        post: _ctx.post,
        highlight: _ctx.highlightContent,
        class: "q-pa-md q-ma-none"
      }, null, 8, ["post", "highlight"]),
      (_ctx.actions)
        ? (_openBlock(), _createBlock(_component_q_card_actions, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_post_actions, { post: _ctx.post }, null, 8, ["post"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}